import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignInSuccess, onSignOutSuccess } from '../store/auth/sessionSlice'

const BaseService = axios.create({
    timeout: 60000,
    withCredentials: true,
    baseURL: appConfig.apiPrefix,
})

BaseService.interceptors.request.use(
    (config) => {
        const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
        const persistData = deepParseJson(rawPersistData)

        let accessToken = persistData?.auth?.session?.token

        if (!accessToken) {
            const { auth } = store.getState()
            accessToken = auth.session.token
        }

        if (accessToken) {
            config.headers[
                REQUEST_HEADER_AUTH_KEY
            ] = `${TOKEN_TYPE}${accessToken}`
        }

        // Ensure Content-Type is preserved if already set
        if (!config.headers['Content-Type'] && !config.headers['content-type']) {
            // Only set default if not already set
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

BaseService.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { response } = error
        const originalRequest = error.config;
        
        // إذا كان الطلب هو refresh token نفسه، لا تحاول refresh مرة أخرى
        if (originalRequest.url?.includes('/auth/refresh')) {
            store.dispatch(onSignOutSuccess())
            return Promise.reject(error)
        }
        
        // منع الحلقة اللانهائية: إذا كان الطلب قد حاول refresh من قبل، لا تحاول مرة أخرى
        if (response && response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            
            try {
                const refreshResponse = await axios.post(
                    `${appConfig.apiPrefix}/auth/refresh`,
                    {},
                    { withCredentials: true }
                );
                
                if (refreshResponse.status === 200) {
                    const newToken = typeof refreshResponse.data === 'string' 
                        ? refreshResponse.data 
                        : refreshResponse.data?.access_token || refreshResponse.data;
                    
                    store.dispatch(onSignInSuccess(newToken))
                    
                    // تحديث الـ headers مع الـ token الجديد
                    originalRequest.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${newToken}`;
                    
                    // إعادة الطلب الأصلي مع الـ token الجديد
                    // إذا حصل على 401 مرة أخرى، لن يحاول refresh لأن _retry = true
                    return BaseService(originalRequest);
                }
            } catch (refreshError) {
                console.log('Refresh token failed:', refreshError)
                originalRequest._retry = false;
                store.dispatch(onSignOutSuccess())
                return Promise.reject(refreshError)
            }
        }
        
        // إذا كان الطلب قد حاول refresh من قبل ولا يزال يحصل على 401، رفض الطلب
        // هذا يمنع الحلقة اللانهائية
        if (response && response.status === 401 && originalRequest._retry) {
            return Promise.reject(error)
        }
        
        return Promise.reject(error)
    }
)

export default BaseService
